export default [
  {title: 'Okay', track: 'https://soundcloud.com/nosleeprecords/ceres-okay', lyric: '1-5526V7DQ1sh0'},
  {title: 'Happy In Your Head', track: 'https://soundcloud.com/nosleeprecords/ceres-happy-in-your-head', lyric: '2-n4OlLD900VY0'},
  {title: 'Roll Ur Eyes', track: 'https://soundcloud.com/nosleeprecords/ceres-roll-ur-eyes', lyric: '3-87V6FX38Oasn'},
  {title: '\'91, Your House', track: 'https://soundcloud.com/nosleeprecords/ceres-91-your-house', lyric: '4-H908di3TGQr8'},
  {title: 'Laundry Echo', track: 'https://soundcloud.com/nosleeprecords/ceres-laundry-echo', lyric: '5-g55Qq842565p'},
  {title: 'Spinning Wheel', track: 'https://soundcloud.com/nosleeprecords/ceres-spinning-wheel', lyric: '6-31qER8U4gw2j'},
  {title: 'Loner Blood', track: 'https://soundcloud.com/nosleeprecords/ceres-loner-blood', lyric: '7-s2D57W6OAf2z'},
  {title: 'Choke', track: 'https://soundcloud.com/nosleeprecords/ceres-choke', lyric: '8-509X9oQ0O4nc'},
  {title: 'Talking', track: 'https://soundcloud.com/nosleeprecords/ceres-talking', lyric: '9-qb7T0KxN807u'},
  {title: 'Us', track: 'https://soundcloud.com/nosleeprecords/ceres-us', lyric: '10-i4Uv9t21F6Om'},
  {title: 'Nothing On Your Shoulders', track: 'https://soundcloud.com/nosleeprecords/ceres-nothing-on-your-shoulders', lyric: '11-hU261k11Uu2v'},
  {title: 'Loaf', track: 'https://soundcloud.com/nosleeprecords/ceres-loaf', lyric: '12-1lr9wQbh6805'},
  {title: 'Del-Del', track: 'https://soundcloud.com/nosleeprecords/ceres-del-del', lyric: '13-8g0N17gveH20'},
  {title: 'Baby\'s Breath', track: 'https://soundcloud.com/nosleeprecords/ceres-babys-breath', lyric: '14-g80wA1CnWh18'}
]



/** WEBPACK FOOTER **
 ** ./src/songs.js
 **/